/* app/ui/header/search */

define(
	'app/ui/header/search',[
		'jquery',
		'util/keybinding',
		'velocity',
		'pubsub'
	],
	function ($, Keybinding) {

		var Module;
		var classes;

		var $search;
		var $searchToggle;

		return {
			init: function (classList) {
				Module = this;
				classes = classList;

				Module._initElements();
				Module._initSubscriptions();
				Module._initEvents();
			},

			_initElements: function () {
				$search = $('.js-header__search');
				$searchToggle = $('.js-header__search-toggle');
			},

			_initSubscriptions: function () {
				$.subscribe('/header/navToggle', Module._closeSearch);
			},

			_initEvents: function () {
				$searchToggle.on('click', Module._toggleSearch);
				//Keybinding.bindKey('?', Module._openSearch);
				Keybinding.bindKey('ESC', Module._closeSearch);
			},

			// publish search toggle event
			// show search if collapsed, add padding and scrollable class when animation complete
			// hide search if showing, remove padding and scrollable class before animation begins
			// toggle class on search button
			_toggleSearch: function (event) {
				event.preventDefault();
				$.publish('/header/searchToggle');
				$searchToggle.toggleClass(classes.expanded);

				if ($search.hasClass(classes.collapsed)) {
					Module._focusSearch();
					$search.velocity(
						{
							height: '100%',
							paddingTop: 46
						},
						{
							duration: 250,
							begin: Module._searchOpening,
							complete: Module._searchOpened
						}
					);
				} else {
					$search.velocity(
						{
							height: '0%',
							paddingTop: 0
						},
						{
							duration: 250,
							begin: Module._searchClosing,
							complete: Module._searchClosed
						}
					);
				}
			},

			_searchOpening: function () {
				$.publish('/header/toggleDropdown', { transform: 'addClass' });
			},

			_searchOpened: function () {
				$search.removeClass(classes.collapsed);
			},

			_searchClosing: function () {
				$search.addClass(classes.collapsed);
			},

			_searchClosed: function () {
				$.publish('/header/toggleDropdown', { transform: 'removeClass' });
				$.publish('/window/scroll'); // Cause sticky nav to re-evaluate
			},

			// move cursor focus to the search input
			_focusSearch: function () {
				$search.find('.js-header__search-input').focus();
			},

			// open search if closed
			_openSearch: function () {
				if (!$searchToggle.hasClass(classes.expanded)) {
					$searchToggle.trigger('click');
				}
			},

			// close search if open
			_closeSearch: function () {
				if ($searchToggle.hasClass(classes.expanded)) {
					$searchToggle.trigger('click');
				}
			}
		};
	}
);
